<template>
    <div class="calendar-wrapper">
        <Calendar :first-instance="firstInstance" :last-instance="lastInstance"/>
    </div>
</template>

<script>
    import Calendar from "./components/Calendar"

    export default {
        name: "App",
        props: ['firstInstance', 'lastInstance'],
        components: {
            Calendar
        },
    }
</script>
